import { Box, Grid, Paper, Typography } from '@mui/material';
import React, { Component } from 'react';
import Global from "../../../customlib/Global";

class PerpindahanContactMobile extends Component {
    state = {  } 
    render() { 
        return (
            <Box>
                <Paper style={{backgroundColor: "#e7eef4", padding: "10px"}}>
                    <Typography variant='h6'>Contact Info</Typography>
                    <div style={{height: "1px", backgroundColor: "#d3d3d3", marginBottom: "20px"}}></div>

                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <Box>
                                <Box><strong>Nama</strong></Box>
                                <Box>{this.props.contactInfo.fromName ?? "-"}</Box>
                            </Box>
                            <Box>
                                <Box><strong>Nomor</strong></Box>
                                <Box>{this.props.contactInfo.from ?? "-"}</Box>
                            </Box>
                            <Box>
                                <Box><strong>Label</strong></Box>
                                <Box>{this.props.contactInfo.label ?? "-"}</Box>
                            </Box>
                        </Grid>
                        <Grid item xs={6}>
                            <Box>
                                <Box><strong>User</strong></Box>
                                <Box>{this.props.contactInfo.ssignToUserName ?? "-"}</Box>
                            </Box>
                            <Box>
                                <Box><strong>Waktu Inbox terakhir</strong></Box>
                                <Box>{this.props.contactInfo.lastMessageReceivedAt ? Global.formatDateTimeToStrDateTime24(this.props.contactInfo.lastMessageReceivedAt, true) : "-"}</Box>
                            </Box>
                            <Box>
                                <Box><strong>Pesan terakhir</strong></Box>
                                <Box>{this.props.contactInfo.lastMessage ?? "-"}</Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>

                <Box>
                    {
                        this.props.listRiwayat.map(item => {
                            return (
                            <Paper sx={{mb: "8px", mt: "5px", padding: "5px"}}>
                                <Box sx={{fontWeight: "bold"}}>{Global.formatDateTimeToStrDateTime24(item.created_at, true)}</Box>
                                <Grid container spacing={1}>
                                    <Grid item xs={6}>
                                        <Box sx={{fontWeight: "bold"}}>Pelaku</Box>
                                        <Box>{item.executorName}</Box>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Box sx={{fontWeight: "bold"}}>Target</Box>
                                        <Box>{item.userNameAfter}</Box>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={1} sx={{mt: "3px"}}>
                                    <Grid item xs={12}>
                                        <Box sx={{fontWeight: "bold"}}>Fungsi</Box>
                                        <Box>{item.functionName}</Box>
                                    </Grid>
                                </Grid>
                            </Paper>
                            );
                        })
                    }
                </Box>
            </Box>
        );
    }
}
 
export default PerpindahanContactMobile;